import React from 'react';
import { ComponentLibraryLoader } from '@unite-us/app-components';
import { datadogRum } from '@datadog/browser-rum';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Notifier from 'common/helpers/Notifier';
import { browserHistory } from 'common/utils/browserHistory';
import { hint2552ShowNewProviderAdmin as hint2552ShowNewProviderAdminSelector } from 'common/utils/FeatureFlags/flags';
import { apiV1, authApi, searchAPIClient } from 'src/api/config';
import useTrackEvent from 'src/components/Organization/utils/useTrackEvent';
import { env } from 'src/config/env';
import './ProviderAdmin.scss';

const AppPA = ComponentLibraryLoader({
  loadFn: () => import('@unite-us/app-provider-admin'),
  component: 'AppProviderAdmin',
  loadingApp: 'app-client',
  source: 'app-provider-admin',
  datadogRum,
});

const getBasename = ({ pathname, route, basename = '' }) => {
  const path = pathname.split(route).at(0);
  return `${basename}${path}${route}`;
};

const ProviderAdmin = ({ hint2552ShowNewProviderAdmin, currentProviderId }) => {
  if (!hint2552ShowNewProviderAdmin) {
    browserHistory.push('/');
    setTimeout(() => {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    }, []);
    return null;
  }

  const basename = getBasename({
    // eslint-disable-next-line no-restricted-globals
    basename: location.basename,
    // eslint-disable-next-line no-restricted-globals
    pathname: location.pathname,
    route: 'provider-admin',
  });

  return (
    <AppPA
      adapters={{
        apiV1,
        authApi,
        searchApi: searchAPIClient,
      }}
      appSettings={{
        endpoints: {
          providerOnboarding: {
            url: env.PROVIDER_ONBOARDING_API,
          },
        },
        providerId: currentProviderId,
      }}
      basename={basename}
      callbacks={{
        notify: {
          error: (message) => Notifier.dispatch('error', message),
          success: (message) => {
            Notifier.dispatch('success', message);
          },
          warn: (message) => Notifier.dispatch('warning', message),
        },
        useTrackEvent,
      }}
    />
  );
};

ProviderAdmin.propTypes = {
  currentProviderId: PropTypes.string.isRequired,
  hint2552ShowNewProviderAdmin: PropTypes.bool,
};

ProviderAdmin.defaultProps = {
  hint2552ShowNewProviderAdmin: false,
};

function mapStateToProps(state) {
  const currentProviderId = state.session.groupId;
  const hint2552ShowNewProviderAdmin = hint2552ShowNewProviderAdminSelector(state);
  return {
    currentProviderId,
    hint2552ShowNewProviderAdmin,
  };
}

export default connect(mapStateToProps)(ProviderAdmin);
